/**
 * Created by andrey on 23.05.2025
 */

const YandexLogger = function () {
    this.config = {
        lifetime: "365 days"
    };
};

YandexLogger.prototype.trackEvent = function (name, params) {
    this.reachGoal(name, {
        order_price: params && params.value || 1
    });
};

YandexLogger.prototype.trackPurchase = function (product, purchase, params) {
    const daysSinceRegistration = connector.metrics.getDaysSinceRegistration();

    const goalParams = {
        order_price: params.price,
        currency: params.currency
    };

    this.reachGoal("purchase", { ...goalParams });

    [7, 30, 90, 365].filter((days) => daysSinceRegistration < days).forEach((days) => {
        this.reachGoal(`purchase_d${days}`, { ...goalParams });
    });
};

YandexLogger.prototype.trackAdRevenue = function (name, impressionCost) {
    const daysSinceRegistration = connector.metrics.getDaysSinceRegistration();

    const params = {
        order_price: impressionCost * connector.EXCHANGE_RATES.RUB,
        currency: "RUB"
    };

    this.reachGoal("ad_revenue", { ...params });

    [7, 30, 90, 365].filter((days) => daysSinceRegistration < days).forEach((days) => {
        this.reachGoal(`ad_revenue_d${days}`, { ...params });
    });
};

YandexLogger.prototype.reachGoal = function (name, params) {
    console.log("yandex logger", name, params);

    if (typeof ysdk === "undefined") {
        return;
    }

    ysdk.analytics.yaMetrikaCounter.reachGoal(connector.config.yandex.counter, name, params);
};

YandexLogger.isApplicable = function () {
    return connector.platform.oneOf(connector.YANDEX) && connector.config.yandex && connector.config.yandex.counter;
};